import { useEffect, useState } from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import { AppLoader } from "../../Components/common/AppLoader/AppLoader";
import { ArticleCard } from "../../Components/ui/ArticleCard/ArticleCard";
import {
  fetchNewsArticles,
  mapArticleToHomeCardProps,
} from "../../api/newsArticlesApi";
import { getSpecialtyNames } from "../../utils/doctorHelpers";
import { fetchSpecialties } from "../../api/doctorApi";
import aboutusBg from "../../assets/images/aboutus-bg.png";
import "../../Components/ui/ArticleCard/ArticleCard.css";
import "../home/newsarticles/newsarticles.css";
import "./newsarticals.css";

export const Newsarticals = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const [articleRows, specialtyRows] = await Promise.all([
          fetchNewsArticles(),
          fetchSpecialties(),
        ]);
        if (cancelled) return;

        const specialtyNames = getSpecialtyNames(specialtyRows);
        setArticles(articleRows.map((article) =>
          mapArticleToHomeCardProps(article, specialtyNames),
        ));
      } catch (err) {
        if (!cancelled) setError(err.message || "Failed to load news articles.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <section
        className="na-hero"
        style={{ backgroundImage: `url(${aboutusBg})` }}
      >
        <div className="store-page__hero-overlay">
          <Container>
            <p className="store-page__hero-label">News & Articles</p>
            <h1 className="store-page__hero-title">
              Connecting Doctor to trusted care worldwide and seamless support.
            </h1>
          </Container>
        </div>
      </section>

      <section className="na-list-section">
        <Container fluid className="news__container">
          {loading && (
            <AppLoader className="py-5" />
          )}

          {!loading && error && (
            <p className="text-center py-4 text-danger">{error}</p>
          )}

          {!loading && !error && (
            <Row className="g-4">
              {articles.length > 0 ? (
                articles.map((article) => (
                  <Col key={article.id} xs={12} md={6} lg={4}>
                    <ArticleCard {...article} />
                  </Col>
                ))
              ) : (
                <Col xs={12}>
                  <p className="news__empty">No articles available yet.</p>
                </Col>
              )}
            </Row>
          )}
        </Container>
      </section>
    </>
  );
};
